module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('form', {
    staticClass: "form-signin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text",
      "name": "account",
      "placeholder": "請輸入帳號"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "請輸入密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.comfirm) ? _c('div', {
    staticClass: "warning"
  }, [_vm._v("帳號或密碼未輸入")]) : _vm._e(), _vm._v(" "), (_vm.userLoginError) ? _c('div', {
    staticClass: "warning"
  }, [_vm._v("帳號或密碼錯誤")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-submit",
    on: {
      "click": _vm.submitLogin
    }
  }, [_vm._v("送出")]), _vm._v(" "), _c('div', {
    staticClass: "form-signin__fg_pw",
    on: {
      "click": _vm.goForgetPassword
    }
  }, [_vm._v("忘記密碼")])]), _vm._v(" "), _c('div', {
    staticClass: "login-desc"
  }, [_c('p', [_vm._v("登入功能僅限 OneBrandMaster 合作夥伴使用，")]), _vm._v(" "), _c('p', [_vm._v("如有登入需求，請與"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("mailto:" + _vm.email)
    }
  }, [_vm._v("我們聯繫！")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fb29c6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 137
// module chunks = 18